import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { CaseDataService } from "../../../../services/SubmissionService";

import { useCallback } from "react";

export default function CaseData({
    submission,
}: {
    submission: APIModels.Submission;
}) {
    const [updatedCaseData, setUpdatedCaseData] = useState(
        submission?.caseData
    );
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isEditable, setIsEditable] = useState(false);

    useEffect(() => {
        setUpdatedCaseData(submission.caseData);
    }, [submission]);

    const onSaveClick = useCallback(
        async (updatedCaseData) => {
            console.log(updatedCaseData?.submissionID);
            await CaseDataService.update({
                id: updatedCaseData?.submissionID,
                body: updatedCaseData,
            }).then(
                (resp) => {
                    console.log(resp);
                    if (resp.successful && resp.data !== (null || undefined)) {
                        setSaving(true);
                        setUpdatedCaseData(resp?.data);
                    } else if (!resp.successful) {
                        console.log(resp.errorMessage);
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
            setSaving(false);
            setIsEditable(!isEditable);
        },
        [updatedCaseData]
    );

    /*
      ,[IsPunitive] b
      ,[JudicialOfficerID]
    */

    return (
        <div className="card text-center">
            <div className="card-body">
                <div style={{ float: "inline-start" }}>
                    <h5 style={{ alignItems: "left" }}>
                        Case Data Editable Fields
                    </h5>
                    <a
                        className="btn btn-secondary btn-sm"
                        onClick={() => setIsEditable(!isEditable)}
                    >
                        {!isEditable ? "Edit" : "Editing"}
                    </a>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>County</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailCounty"
                                placeholder="Edit County"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.county}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        county: event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid County.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Division</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailDivision"
                                placeholder="Edit Division"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.division}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        division: event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Division.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Case Type</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailCase Type"
                                placeholder="Edit Case Type"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.caseType}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        caseType: event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Case Type.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Case Sub Type</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailCase Sub Type"
                                placeholder="Edit Case Sub Type"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.caseSubType}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        caseSubType: event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Case Sub Type.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Court Case Number</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailCourtCaseNumber"
                                placeholder="Edit Court Case Number"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.courtCaseNumber}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        courtCaseNumber:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid CourtCaseNumber.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>
                            Client Case Number
                        </h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailClientCaseNumber"
                                placeholder="Edit Client Case Number"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.clientCaseNumber}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        clientCaseNumber:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Client Case Number.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Case Title</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailCaseTitle"
                                placeholder="Edit Case Title"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.caseTitle}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        caseTitle: event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Case Title.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>CVV</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailCVV"
                                placeholder="Edit CVV"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.cvv}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        cvv: event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid CVV.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Claim Amount</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailCVV"
                                placeholder="Edit Claim Amount"
                                aria-describedby="inputGroupPrepend"
                                readOnly={!isEditable}
                                value={updatedCaseData?.claimAmount}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        claimAmount: event.currentTarget.value,
                                    })
                                }
                                disabled={!isEditable}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Claim Amount.
                            </div>
                        </div>
                    </div>
                </div>
                {isEditable && (
                    <>
                        <a
                            className="btn btn-primary"
                            onClick={() => {
                                onSaveClick(updatedCaseData);
                            }}
                        >
                            Save
                        </a>
                        <a
                            className="btn btn-danger"
                            onClick={() => {
                                setIsEditable(!isEditable);
                                setUpdatedCaseData(submission.caseData);
                            }}
                        >
                            Cancel
                        </a>
                    </>
                )}
                <h5>Case Data Uneditable Fields</h5>
                <div className="row mb-3">
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>ID</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailID"
                                placeholder="Edit ID"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.id}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        id: event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Submission ID</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailID"
                                placeholder="Edit Submission ID"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.submissionID}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        submissionID: event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Submission ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>UCN</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailUCN"
                                placeholder="Edit UCN"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.ucn}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        ucn: event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid UCN.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Year</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailYear"
                                placeholder="Edit Year"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.year}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        year: event.currentTarget.valueAsNumber,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Year.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Sequence Number</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailSequenceNumber"
                                placeholder="Edit Sequence Number"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.sequenceNumber}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        sequenceNumber:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Sequence Number.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>
                            Client Matter Number
                        </h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailClientMatterNumber"
                                placeholder="Edit Client Matter Number"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.clientMatterNumber}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        clientMatterNumber:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Client Matter Number.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>
                            Begin Service Date
                        </h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailBeginServiceDate"
                                placeholder="Edit Begin Service"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.beginDateOfService}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        beginDateOfService:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Begin Service Date.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>
                            Cause of Action Count
                        </h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailCauseOfActionCount"
                                placeholder="Edit Cause of Action Count"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.causeOfActionCount}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        causeOfActionCount:
                                            event.currentTarget.valueAsNumber,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Cause of Action Count.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Date of Accident</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailDateOfAccident"
                                placeholder="Edit Date of Accident"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.dateOfAccident}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        dateOfAccident:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Date of Accident.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>
                            End Date Of Service
                        </h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailEndDateOfService"
                                placeholder="Edit End Date of Service"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.endDateOfService}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        endDateOfService:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid End Date of Service.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Payment Token</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailPaymentToken"
                                placeholder="Edit Payment Token"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.paymentToken}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        paymentToken: event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Payment Token.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>
                            Related Case Number
                        </h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailRelatedCaseNumber"
                                placeholder="Edit Related Case Number"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.relatedCaseNumber}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        relatedCaseNumber:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Related Case Number.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>
                            Small Claims Amount
                        </h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailSmallClaimsAmount"
                                placeholder="Edit Small Claims Amount"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.smallClaimsAmount}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        smallClaimsAmount:
                                            event.currentTarget.valueAsNumber,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Small Claims Amount.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Subpoena Count</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailSubpoenaCount"
                                placeholder="Edit Subpoena Count"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.subpoenaCount}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        subpoenaCount:
                                            event.currentTarget.valueAsNumber,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Subpoena Count.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Summons Count</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailSummonsCount"
                                placeholder="Edit Summons Count"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.summonsCount}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        summonsCount:
                                            event.currentTarget.valueAsNumber,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Summons Count.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Total Defendants</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailTotalDefendants"
                                placeholder="Edit Total Defendants"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.totalDefendants}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        totalDefendants:
                                            event.currentTarget.valueAsNumber,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Total Defendants.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>EFME Case Type</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailEFMECaseType"
                                placeholder="Edit EFME Case Type"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.efmeCaseType}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        efmeCaseType: event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid EFME Case Type.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>Damage Code ID</h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailDamageCodeID"
                                placeholder="Edit Damage Code ID"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.damagesCodeID}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        damagesCodeID:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Damages Code ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <h6 style={{ textAlign: "left" }}>
                            Judicial Officer ID
                        </h6>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailJudicialOfficerID"
                                placeholder="Edit Date of Accident"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedCaseData?.judicialOfficerID}
                                onChange={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        judicialOfficerID:
                                            event.currentTarget.value,
                                    })
                                }
                                disabled={true}
                            />
                            <div className="invalid-feedback">
                                Please provide a valid Judicial Officer ID.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailDemandForJuryTrial"
                                readOnly={true}
                                onClick={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        demandForJuryTrial:
                                            event.currentTarget.checked,
                                    })
                                }
                                disabled={true}
                                checked={updatedCaseData?.demandForJuryTrial}
                            />
                            <label className="form-check-label">
                                <h6>Demand For Jury Trial?</h6>
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailHasRelatedCases"
                                readOnly={true}
                                onClick={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        hasRelatedCases:
                                            event.currentTarget.checked,
                                    })
                                }
                                disabled={true}
                                checked={updatedCaseData?.hasRelatedCases}
                            />
                            <label className="form-check-label">
                                <h6>Has Related Cases?</h6>
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailIsClassAction"
                                readOnly={true}
                                onClick={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        isClassAction:
                                            event.currentTarget.checked,
                                    })
                                }
                                disabled={true}
                                checked={updatedCaseData?.isClassAction}
                            />
                            <label className="form-check-label">
                                <h6>Is Class Action?</h6>
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailIsComplexBuisness"
                                readOnly={true}
                                onClick={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        isComplexBusiness:
                                            event.currentTarget.checked,
                                    })
                                }
                                disabled={true}
                                checked={updatedCaseData?.isComplexBusiness}
                            />
                            <label className="form-check-label">
                                <h6>Is Complex Buisness?</h6>
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailIsInjunctiveRelief"
                                readOnly={true}
                                onClick={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        isInjunctiveRelief:
                                            event.currentTarget.checked,
                                    })
                                }
                                disabled={true}
                                checked={updatedCaseData?.isInjunctiveRelief}
                            />
                            <label className="form-check-label">
                                <h6>Is Injunctive Relief?</h6>
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailIsMonetary"
                                readOnly={true}
                                onClick={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        isMonetary: event.currentTarget.checked,
                                    })
                                }
                                disabled={true}
                                checked={updatedCaseData?.isMonetary}
                            />
                            <label className="form-check-label">
                                <h6>Is Monetary?</h6>
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailIsNonMonetary"
                                readOnly={true}
                                onClick={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        isMonetary: event.currentTarget.checked,
                                    })
                                }
                                disabled={true}
                                checked={updatedCaseData?.isClassAction}
                            />
                            <label className="form-check-label">
                                <h6>Is Non-Monetary?</h6>
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-checkinput"
                                id="chkDetailIsPunitive"
                                readOnly={true}
                                onClick={(event) =>
                                    setUpdatedCaseData({
                                        ...updatedCaseData,
                                        isPunitive: event.currentTarget.checked,
                                    })
                                }
                                disabled={true}
                                checked={updatedCaseData?.isPunitive}
                            />
                            <label className="form-check-label">
                                <h6>Is Punitive?</h6>
                            </label>
                            <div className="invalid-feedback">
                                Please provide a valid Portal Identifier.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
